import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.css';
import BlueBookButton from '../bluebook-button/BlueBookButton';

const DisclosureItem = ({ title, description, isExpanded, toggle }) => {
  const ariaControl = `${title}_desc`;
  const ariaExpandable = `${title}_button`;
  return (
    <>
      <dt className="border-t border-gray-300">
        <BlueBookButton
          id={ariaExpandable}
          accessibility={{
            'aria-expanded': isExpanded,
            'aria-controls': ariaControl,
          }}
          size="medium"
          isRounded={false}
          className="!whitespace-normal text-gray-900 py-8.8 px-8.4 !flex w-full justify-between text-default h-auto bg-none text-bluebook-blue border-none hover:underline"
          onClick={toggle}
        >
          <span className="text-left mr-8.4">{title}</span>
          {/* expand (+) and collapse (-) icons with "flip" animation */}
          <div className="relative mr-8.4">
            <div
              className={cn(
                'border-b-2 border-black w-5 ease-linear duration-300 absolute',
                {
                  'rotate-90 left-[1.25px]': !isExpanded,
                },
              )}
            />
            <div className="border-b-2 border-black w-6 absolute" />
          </div>
        </BlueBookButton>
      </dt>
      <dd
        className={cn(
          { block: isExpanded, hidden: !isExpanded },
          'm-0 rounded',
        )}
        id={ariaControl}
        role="region"
        aria-labelledby={ariaExpandable}
      >
        <div className={cn(styles['disclosure-dd-gradient'])} />
        <div className="pt-2 pb-8.8 px-8.4 leading-8 bg-bluebook-light-gray">
          {description}
        </div>
      </dd>
    </>
  );
};

DisclosureItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  isExpanded: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default DisclosureItem;
